/**
 * 播放音频相关方法
 */
import getAsyncResult from "./promise/getAsyncResult";
import { showTips, hideTips } from "./prompt/main";
var ua = navigator.userAgent.toLocaleLowerCase();
var isApp = ua.indexOf("kidlearning_inapp_android") > -1 || ua.indexOf("kidlearning_inapp_ios") > -1 ? true : false;
var curPlayingAudioUrl = "";

const h5PlayAudio = {

    canAutoPlayAudio: false,    // 是否可以自动播放
    playAudio: document.getElementById("playAudio"),
    timeoutId: null,

    createAudioPlay: function () {
        var audio = document.createElement('audio');  //生成一个audio元素
        audio.id = "playAudio";  //这样控件才能显示出来
        audio.controls = false;  //这样控件才能显示出来
        audio.src = "https://webres.putaoabc.com/course/mp3/none.mp3";  //音乐的路径
        // audio.autoplay = "true";
        document.body.appendChild(audio); //把它添加到页面中
        this.playAudio = document.getElementById("playAudio");
    },

    // 校验是否支持自动播放
    checkAutoPlay: function () {
        const that = h5PlayAudio;
        if (!that.playAudio) {
            that.createAudioPlay();
        }
        return new Promise((resolve, reject) => {
            that.playAudio.src = "https://webres.putaoabc.com/course/mp3/none.mp3";  //防止被清掉
            const playAudioPromise = that.playAudio.play();
            playAudioPromise.then(_ => {
                that.canAutoPlayAudio = true;
                that.removeListenerClickAudio();
                resolve();
            }).catch(error => {
                if (error && typeof error === "object" && error.name && error.name === "NotAllowedError") { // 不能自动播放
                    document.addEventListener("touchstart", that.listenerClickAudio, false);
                    document.addEventListener("mousedown", that.listenerClickAudio, false);
                }
                reject(error);
            })
        });
    },

    listenerClickAudio: function () {
        const that = h5PlayAudio;
        that.playAudio.src = "https://webres.putaoabc.com/course/mp3/none.mp3";  //防止被清掉
        const playAudioPromise = that.playAudio.play();
        playAudioPromise.then(_ => {
            that.canAutoPlayAudio = true;
            that.removeListenerClickAudio();
        }).catch(error => {
        })
    },

    removeListenerClickAudio: function () {
        const that = this;
        document.removeEventListener("touchstart", that.listenerClickAudio, false);
        document.removeEventListener("mousedown", that.listenerClickAudio, false);
    },

    playStart: function (url, startCallback, endCallback, failCallback) {
        var that = this;
        if (!that.playAudio) {
            that.createAudioPlay();
        }
        // 为了解决多个音频快速点击，动画不会消失（原因是回调函数没有执行）的问题，需要先执行一下上一次的回调再播放
        // !playAudio.paused —— 判断音频是否正在播放，为了解决前面页 也会回调的问题（前面页不需要再专门执行回调了）
        // playAudio.src && url !== playAudio.src —— 如果同时点击两次，问题：音频会播放，但是动画没有了。原因：同时点击，回调函数会过早执行，导致动画提前结束，看起来像是动画没有播
        if (
            that.playAudio.src && (that.playAudio.src.indexOf('.mp3') > -1 || that.playAudio.src.indexOf('.wav') > -1) &&
            (url !== that.playAudio.src || that.playAudio.src.indexOf(url) > -1) &&
            // !playAudio.paused &&
            that.playAudio.onended && typeof that.playAudio.onended === "function"
        ) {
            that.playAudio.onended();
        }
        that.playAudio.src = url;

        const playAudioPromise = that.playAudio.play();
        if (playAudioPromise !== undefined) {
            playAudioPromise
                .then(_ => {
                    if (startCallback && typeof startCallback === "function") {
                        startCallback(url);
                    }
                    //音频播放完成
                    that.playAudio.onended = function () {
                        that.playAudio.onended = null;
                        if (endCallback && typeof endCallback === "function") {
                            endCallback(url);
                        }
                    };
                })
                .catch(error => {
                    // console.log('===noplay', error)
                    if (failCallback && typeof failCallback === "function") {
                        failCallback(error);
                        if (window.PTMonitor && window.PTMonitor.report) {
                            try {
                                window.PTMonitor.report({
                                    type: 'mediaEx',
                                    url: window.location.href,
                                    putaoid: window.localStorage.getItem("putaoid") || window.localStorage.getItem("openId"),
                                    info: url + ' play error!',
                                    stack: "H5PlayAudio.playStart"
                                }, window.EX_TYPE.mediaEx);
                            } catch (err) { }
                        }
                    }
                });
        } else {    //兼容ios9
            that.playAudio.oncanplay = function () {
                let duration = that.playAudio.duration;
                setTimeout(() => {
                    if (endCallback && typeof endCallback === "function") {
                        endCallback(url);
                    }
                }, duration * 1000)
            }
        }
    },

    playAudioFun: function (data) {
        const that = this;
        const { showTipsDialog, url, endCallback, failCallback } = data;
        curPlayingAudioUrl = url;

        // 不能自动播放的时候先校验
        if (!that.canAutoPlayAudio) {
            getAsyncResult(that.checkAutoPlay(), 1000).then(() => {
                that.playSelfAudio(data);    // 调用h5的音频播放方法
                hideTips();
            }).catch((error) => {
                if (isApp) {    // 调用app的音频播放方法
                    getAsyncResult(that.useAppPlayAudio(data), 25000).then(() => {
                        if (endCallback && typeof endCallback === "function") {
                            console.log('=====end true')
                            endCallback(url);
                        }
                    }).catch((error2) => {
                        if (endCallback && typeof endCallback === "function") {
                            console.log('=====end false')
                            endCallback(url);
                        }
                        if (window.PTMonitor && window.PTMonitor.report) {
                            try {
                                window.PTMonitor.report({
                                    type: 'mediaEx',
                                    putaoid: "-1",
                                    info: url + ' app play error!',
                                    stack: error2
                                }, window.EX_TYPE.mediaEx);
                            } catch (err) { }
                        }
                    });
                } else {
                    if (showTipsDialog !== false) {
                        showTips("检测到系统不能自动播放音频，请点击这里播放。", -1, () => {
                            that.playSelfAudio(data);
                        });
                    }
                    if (failCallback && typeof failCallback === "function") {
                        failCallback({ "code": -1, "msg": "浏览器不支持自动播放！" });
                    }
                    if (window.PTMonitor && window.PTMonitor.report) {
                        try {
                            window.PTMonitor.report({
                                type: 'mediaEx',
                                putaoid: "-1",
                                info: url + ' self play error!',
                                stack: error
                            }, window.EX_TYPE.mediaEx);
                        } catch (err) { }
                    }
                }
            });
        } else {
            that.playSelfAudio(data);
        }
    },

    playSelfAudio: function (data) {
        var that = this;
        const { url, startCallback, endCallback, failCallback, needCloseAfterCallback, playingCallback, onPause, timeout } = data;
        that.timeoutId && clearTimeout(that.timeoutId);
        if (!that.playAudio) {
            that.createAudioPlay();
        }


        // 为了解决多个音频快速点击，动画不会消失（原因是回调函数没有执行）的问题，需要先执行一下上一次的回调再播放
        // !playAudio.paused —— 判断音频是否正在播放，为了解决前面页 也会回调的问题（前面页不需要再专门执行回调了）
        // playAudio.src && url !== playAudio.src —— 如果同时点击两次，问题：音频会播放，但是动画没有了。原因：同时点击，回调函数会过早执行，导致动画提前结束，看起来像是动画没有播
        if (
            !needCloseAfterCallback && that.playAudio.src && (that.playAudio.src.indexOf('.mp3') > -1 || that.playAudio.src.indexOf('.wav') > -1) &&
            (url !== that.playAudio.src || that.playAudio.src.indexOf(url) > -1) &&
            // !playAudio.paused &&
            that.playAudio.onended && typeof that.playAudio.onended === "function"
        ) {
            that.playAudio.onended();
        }
        that.playAudio.src = url;

        // 在微信的水平测试 https://courses-1256571289.cos.ap-beijing.myqcloud.com/examJson/101_1_2.json 第四题，不加play放大，音频播放点不了，因此加上下面的play
        const playAudioPromise = that.playAudio.play();
        if (playAudioPromise !== undefined) {
            playAudioPromise.then(_ => {
            }).catch(error => {
                if (failCallback && typeof failCallback === "function") {
                    failCallback(error);
                    if (window.PTMonitor && window.PTMonitor.report) {
                        try {
                            window.PTMonitor.report({
                                type: 'mediaEx',
                                url: window.location.href,
                                putaoid: "-1",
                                info: url + ' play error!',
                                stack: "H5PlayAudio.playStart"
                            }, window.EX_TYPE.mediaEx);
                        } catch (err) { }
                    }
                }
            });
        }

        that.playAudio.onplay = function () {
            console.log('=====onplay')
            that.canAutoPlayAudio = true;
            that.removeListenerClickAudio();
            if (startCallback && typeof startCallback === "function") {
                startCallback(url, that.playAudio.duration);
            }
        }
        //  音频播放中的回调
        that.playAudio.ontimeupdate = function () {
            // console.log('=====playing', that.playAudio.currentTime)
            if (playingCallback && typeof playingCallback === "function") {
                playingCallback(url, that.playAudio.currentTime || 0);    // 参数是当前播放的音频
            }
        }
        //  音频暂停的回调
        that.playAudio.onpause = function () {
            that.playAudio.onpause = null;
            if (onPause && typeof onPause === "function") {
                onPause(url, that.playAudio.currentTime || 0);    // 参数是当前播放的音频
            }
        }
        //音频播放完成
        that.playAudio.onended = function () {
            clearTimeout(that.timeoutId);
            that.playAudio.onended = null;
            if (endCallback && typeof endCallback === "function") {
                endCallback(url);
            }
        }
        //音频播放出错
        that.playAudio.onerror = function () {
            clearTimeout(that.timeoutId);
            that.playAudio.onerror = null;
            if (failCallback && typeof failCallback === "function") {
                failCallback(url);
            }
        }

        if (timeout && endCallback && typeof endCallback === "function") {
            that.timeoutId = setTimeout(() => {
                endCallback(url);
            }, timeout);
        }

    },

    playPause: function (data) {
        let url = data && data.url ? data.url : curPlayingAudioUrl;
        let callback = data && data.callback ? data.callback : "";
        if (this.playAudio) {
            if (!this.canAutoPlayAudio && isApp && url) {
                if (window.appAudioPause) {
                    window.appAudioPause(url);   //停止音频播放
                } else if (window.android && window.android.appAudioPause) {
                    window.android.appAudioPause(url);
                }
            } else {
                this.playAudio.pause();
            }
        }

        if (callback && typeof callback === "function") {
            callback();
        }
    },

    playStop: function (data) {
        const that = h5PlayAudio;
        let url = data && data.url ? data.url : curPlayingAudioUrl;
        let callback = data && data.callback ? data.callback : "";

        if (isApp && url) {
            if (window.appAudioStop) {
                window.appAudioStop(url);   //停止音频播放
            } else if (window.android && window.android.appAudioStop) {
                window.android.appAudioStop(url);
            }
        }
        that.playAudio && (that.playAudio.src = "");
        curPlayingAudioUrl = "";

        if (callback && typeof callback === "function") {
            callback();
        }
    },

    // 调用app的音频播放方法
    useAppPlayAudio: function (data) {
        var that = this;
        that.timeoutId && clearTimeout(that.timeoutId);
        return new Promise((resolve, reject) => {
            const { url, startCallback, playingCallback, timeout } = data;

            window.appAudioPlayCallback = (url) => {
                clearTimeout(that.timeoutId);
                window.appAudioPlayCallback = null;
                resolve(1);
            }
            window.appStartPlayAudioCallback = (time, url) => {
                window.appStartPlayAudioCallback = null;
                that.removeListenerClickAudio();
                if (startCallback && typeof startCallback === "function") {
                    startCallback(url, time);
                }
            }
            window.appPlayingAudioCallback = (url, duration) => {
                if (playingCallback && typeof playingCallback === "function") {
                    // console.log('=====appPlayingAudioCallback', url, duration)
                    playingCallback(url, duration);
                }
            }

            if (window.appPicbookAudioPlay) {
                window.appPicbookAudioPlay(url);   //将音频传给app进行播放，播放完调用 window.appAudioPlayCallback 结束播放
            } else if (window.android && window.android.appPicbookAudioPlay) {
                window.android.appPicbookAudioPlay(url);
            }

            if (timeout) {
                that.timeoutId = setTimeout(() => {
                    reject();
                }, timeout);
            }
        });
    }
}

export default h5PlayAudio;



// WEBPACK FOOTER //
// ./src/lib/AudioPlay.js